export default "__VITE_ASSET__6975f84b__"